export const golangData = [
    {
    para1: "IStellar offer high-quality web solutions in python programming language that goes along with Django development. We create secure server-side web applications for you in the fastest terms",
    para2: "We strive to bring state-of-the-art industry practices to build Python applications, with Django, and Flask frameworks, you will get out of the box web solutions by choosing IStellar as your Python development partner",
    ul: [
        {li: "VueJS development",
        path: "/services/vuejs-development"},
        {li: "AngularJS development",
        path: "/services/angular-development"},
        {li: "Angular development",
        path: "services/angular-development"},
        {li: "NodeJS API development",
        path: "/services/nodejs-development"},
        {li: "D3.JS Data Visualization",
        path: "/"},
        {li: "React Native Mobile App Development",
        path: "/services/reactjs-development"},
    ]
}
]
export const golangPara = [
    "Flask is the micro web application framework. It is called a micro framework because it does not require a particular type of tool or libraries. Flask is known to be a dynamic object-oriented programming language. It is the most rapidly growing open source programming language. It supports tools to build up excellent and secure web applications with high-performance levels.",
    "At IStellar, We have a team of Django & flask developers where we focus on bringing your ideas to reality. We have proven track record in achieving client goals and continuous providing extensive Django development services."
]
export const golangImg = [
    "golang"
]
export const golangServicesPara = [
    "We focus on developing and integrating applications using Python. Our development approach ensures that you receive incredibly flexible and secure web solutions."
]
export const PythonPara = [
    {
        h5: "Django",
        para: "Django comes bundled with many essential components that make it faster and easier to build web applications. There's no need to reinvent the wheel and build out custom features when they come ready-to-go in Django.Some of these components include a comprehensive admin interface, templating engine, elegant ORM and schema migrations built-in. These out-of-the-box features support rapid development, making Django web app development remarkably fast."
    }, {
        h5: "Django REST framework",
        para: "The Django REST framework is a fully featured framework for building web APIs. It provides many advantages that make it one of the best toolkits for web API development. The Django REST framework comes with lots of out-of-the-box features, such as a powerful serialization engine, user authentication packages for OAuth, a built in API browser for testing, and integration with many 3rd party libraries. Django REST framework is incredibly flexible and can be moulded to a project's specific needs."
    }
]
export const golangCardData = [
    {
        id: 1,
        title: "Web development",
        content: "We make your business needs into realism by offering powerful and visually appealing and are tailored to your needs through customized Python Web development services."
    }, {
        id: 2,
        title: "Prototype Development",
        content: "We start with a well-crafted design for the prototype that culminated from our rich experience and command over the language. The final product is fast, secure, and perfectly combined with Flask & Django."
    }, {
        id: 3,
        title: "Dedicated Python Developers",
        content: "Our dedicated Python web programmers develop and maintain various software including database, scalable system, back-end architecture, server, command-line apps, APIs, web apps etc.."
    }, {
        id: 4,
        title: "Support and Maintenance",
        content: "Apart from Python web development services, we provide after-sales services like Python application support & maintenance to our existing and proposed clients. At IStellar, our qualified tech support team will be there at your disposal round the clock to provide you continuous support for your business-critical applications."
    }, {
        id: 5,
        title: "API & Web Services development",
        content: "We strengthen your mobile applications or approach to provide access to your platform information via secure, stabilized web services and APIs."
    }, {
        id: 6,
        title: "QA and Testing",
        content: "Our QA team puts in some reasonable efforts for the testing the application. We ensure error-free and seamless functioning of your application and incorporates useful functionality testing, automated testing, load testing, and smart dependency management."
    }
]